/* eslint-disable */
import React from "react";
import Swal from "sweetalert2";
import Common from "../../../../Utils/Common";
import { Link } from "react-router-dom";
import { LoginBackground } from "./LoginPage";

class SignUp extends React.Component {
  constructor(props) {
    super(props);

    if (localStorage.getItem("userIzzi") !== null) {
      window.location.href = "/";
    }

    this.state = {
      username: "",
      name: "",
      newPassword: "",
      rePassword: "",
      mobile: "",
      submitted: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();
    const { email, newPassword, rePassword, name, mobile } = this.state;
    if (newPassword != rePassword) {
      Swal.fire("Mật khẩu xác nhận sai!");
      return;
    }
    var id = Common.guid();
    let objData = {
      Id: id,
      Name: name,
      Mobile: mobile,
      Email: email,
      MerchantCode: window.Merchant.data.code,
      Password: newPassword,
      ModifiedDate: Common.formatDateTime(new Date()),
      ModifiedBy: id,
    };
    Common.sendSyncCommand(
      "RegisterMemberMerchant",
      "CustomerRelationshipManagement",
      objData,
      () => {
        Swal.fire("Cảm ơn đã đăng ký tài khoản.");
        setTimeout(() => {
          window.location.href = "/login";
        }, 3000);
      },
      () => {
        Swal.fire("Đăng kí thất bại!");
      }
    );
  }

  render() {
    const { email, newPassword, submitted, name, mobile, rePassword } = this.state;
    const merchant = window.Merchant.data;
    const izziMember = JSON.parse(merchant.izziMember || "{}");

    return (
      <div
        uk-height-viewport=""
        className="uk-flex uk-flex-middle"
        style={{ minHeight: "calc(100vh);" }}>
        <div className="uk-width-2-3@m uk-width-1-2@s m-auto rounded" style={{ marginTop: "62px" }}>
          <div className="uk-child-width-1-2@m uk-grid-collapse bg-gradient-grey uk-grid" uk-grid>
            {/* column one */}
            <div className="uk-text-center uk-animation-scale-up p-3 uk-light uk-first-column dx-relative">
              {/*<i className=" uil-graduation-hat icon-large" />*/}
              {/*<h3 className="mb-4"> Izzi Learn</h3>*/}
              {/*<p>Nơi mà bạn có thể học mọi thứ. </p>*/}
              <LoginBackground />
            </div>
            {/* column two */}
            <div className="uk-card-default p-5 rounded">
              <div className="mb-4 uk-text-center">
                <h3 className="mb-0">Đăng ký</h3>
                {/*<p className="my-2">Đăng nhập để quản trị tài khoản của bạn.</p>*/}
              </div>
              <form
                id="formSignUp"
                onSubmit={this.handleSubmit}
                name="form"
                className="uk-child-width-1-1 uk-grid-small uk-grid">
                <div className="uk-first-column">
                  <div className="uk-form-group">
                    <label className="uk-form-label"> Tên</label>
                    <div className="uk-position-relative w-100">
                      <span className="uk-form-icon">
                        <i className="icon-feather-user" />
                      </span>
                      <input
                        className="uk-input"
                        type="text"
                        name="name"
                        value={name}
                        onChange={this.handleChange}
                        placeholder="Tên đầy đủ"
                        required
                      />
                      {submitted && !name && (
                        <div className="help-block">Tên là trường bắt buộc.</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="uk-grid-margin uk-first-column">
                  <div className="uk-form-group">
                    <label className="uk-form-label"> Email</label>
                    <div className="uk-position-relative w-100">
                      <span className="uk-form-icon">
                        <i className="icon-feather-mail" />
                      </span>
                      <input
                        className="uk-input"
                        type="email"
                        name="email"
                        value={email}
                        onChange={this.handleChange}
                        placeholder="name@example.com"
                        required
                      />
                      {submitted && !email && (
                        <div className="help-block">Email là trường bắt buộc.</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="uk-grid-margin uk-first-column">
                  <div className="uk-form-group">
                    <label className="uk-form-label"> Số điện thoại</label>
                    <div className="uk-position-relative w-100">
                      <span className="uk-form-icon">
                        <i className="icon-feather-phone" />
                      </span>
                      <input
                        className="uk-input"
                        type="phone"
                        name="mobile"
                        value={mobile}
                        onChange={this.handleChange}
                        placeholder="0912xxxxxx"
                        pattern="[0][0-9]{9}"
                        required
                      />
                      {submitted && !mobile && (
                        <div className="help-block">Số điện thoại là trường bắt buộc.</div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="uk-width-1-2@s uk-grid-margin uk-first-column">
                  <div className="uk-form-group">
                    <label className="uk-form-label"> Mật khẩu</label>
                    <div className="uk-position-relative w-100">
                      <span className="uk-form-icon">
                        <i className="icon-feather-lock" />
                      </span>
                      <input
                        className="uk-input"
                        type="password"
                        name="newPassword"
                        value={newPassword}
                        onChange={this.handleChange}
                        placeholder="********"
                        required
                      />
                      {submitted && !newPassword && (
                        <div className="help-block">Mật khẩu là trường bắt buộc.</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="uk-width-1-2@s uk-grid-margin">
                  <div className="uk-form-group">
                    <label className="uk-form-label"> Xác nhận mật khẩu</label>
                    <div className="uk-position-relative w-100">
                      <span className="uk-form-icon">
                        <i className="icon-feather-lock" />
                      </span>
                      <input
                        className="uk-input"
                        type="password"
                        name="rePassword"
                        value={rePassword}
                        onChange={this.handleChange}
                        placeholder="********"
                        required
                      />
                    </div>
                  </div>
                </div>
                {/* <div className="uk-form-group">
                  <label className="uk-form-label"> Confirm password</label>
                  <div className="uk-position-relative w-100">
                    <span className="uk-form-icon">
                      <i className="icon-feather-lock" />
                    </span>
                    <input className="uk-input" type="password" placeholder="********" />
                  </div>
                </div> */}
                <div className="mt-4 uk-flex-middle uk-grid-small uk-grid" uk-grid>
                  <div className="uk-width-expand@s uk-first-column">
                    <p>
                      {" "}
                      Trở về trang đăng nhập tại{" "}
                      <Link to={"/login"}>
                        <b>đây</b>
                      </Link>
                    </p>
                  </div>
                  <div className="uk-width-auto@s">
                    <button
                      type="submit"
                      style={{ backgroundColor: "#484b77", color: "#fff" }}
                      className="btn btn-default">
                      Bắt đầu
                    </button>
                  </div>
                </div>
              </form>
            </div>
            {/*  End column two */}
          </div>
        </div>
      </div>
    );
  }
}

export default SignUp;
